import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransferOutService {
  private baseUrl = `${environment.apiUrl}/stock-transfer-out`;

  constructor(private http: HttpClient) {}

  createTransferOut(body: any) {
    return this.http.post(`${this.baseUrl}`, body);
  }

  getTransferOuts(
    pageOptions: { page: number; limit: number },
    searchText: string = '',
    filters?: { direction?: 'outgoing' | 'incoming'; status?: string }
  ) {
    let params = new HttpParams()
      .set('page', pageOptions.page)
      .set('limit', pageOptions.limit);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (filters?.direction) {
      params = params.set('direction', filters.direction);
    }
    if (filters?.status) {
      params = params.set('status', filters.status);
    }
    return this.http.get(`${this.baseUrl}`, { params });
  }

  updateTransferOut(id: string, body: any) {
    return this.http.patch(`${this.baseUrl}/${id}`, body);
  }

  getTransferOutById(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  downloadTransferOut(id: string) {
    return this.http.get(`${this.baseUrl}/download/${id}`, {
      responseType: 'blob' as 'blob',
      observe: 'response' as 'response',
    });
  }

  createEwayBill(body: any) {
    return this.http.post(`${environment.apiUrl}/ewaybill/generate`, body);
  }

  createEwayBillDraft(body: any) {
    return this.http.post(`${environment.apiUrl}/ewaybill/draft`, body);
  }

  cancelEwayBill(body: any) {
    return this.http.post(`${environment.apiUrl}/ewaybill/cancel`, body);
  }

  updateEwayBillPartB(body: any) {
    return this.http.post(`${environment.apiUrl}/ewaybill/part-b`, body);
  }

  getEwayBills(pageOptions: { page: number; limit: number }) {
    let params = new HttpParams()
      .set('page', pageOptions.page)
      .set('limit', pageOptions.limit);
    return this.http.get(`${environment.apiUrl}/ewaybill`, { params });
  }

  getNextTransferOutNumber(sourceLocationId?: string) {
    const params: any = {};
    if (sourceLocationId) params.sourceLocationId = sourceLocationId;
    return this.http.get(`${this.baseUrl}/next-number`, { params });
  }

  /**
   * E-way bill estimate for a TO still on screen: consignment value incl.
   * GST and whether it crosses the client threshold.
   */
  quoteEwayBill(body: {
    sourceLocationId: string;
    targetLocationId: string;
    items: { productVariantId: string; quantity: number; variantPricingId?: string | null }[];
  }) {
    return this.http.post(`${this.baseUrl}/eway-bill-quote`, body);
  }

  getPendingEwayBills() {
    return this.http.get(`${this.baseUrl}/pending-eway-bill`);
  }

  downloadTemplate() {
    return this.http.get(`${this.baseUrl}/template`, {
      responseType: 'blob',
    });
  }

  uploadExcel(file: File, sourceLocationId: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sourceLocationId', sourceLocationId);
    return this.http.post(`${this.baseUrl}/upload`, formData);
  }
}
